module.exports = __webpack_public_path__ + "19c73bc57355685340586ac95de38199.fbx";